import { render } from "./Risk.vue?vue&type=template&id=3ad9cafe&scoped=true&ts=true"
import script from "./Risk.vue?vue&type=script&lang=ts"
export * from "./Risk.vue?vue&type=script&lang=ts"

import "./Risk.vue?vue&type=style&index=0&id=3ad9cafe&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad9cafe"]])

export default __exports__